import { IconMoreHorizontal } from '@components/icons/more-horizontal';

import { Menu } from '../menu';

interface JumpToPageProps {
  from: number;
  to: number;
  onSelect: (index: number) => void;
}

export function JumpToPage({ from, to, onSelect }: JumpToPageProps) {
  return (
    <Menu
      buttonProps={{
        variant: 'ghost',
        iconLeft: <IconMoreHorizontal />,
      }}
      maxWidth="8rem"
    >
      {Array.from({ length: to - from + 1 }).map((_, i) => (
        <Menu.Item key={from + i} onSelect={() => onSelect(from + i)} label={from + i} />
      ))}
    </Menu>
  );
}
